import clsx from 'clsx';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ContactIcon } from 'common-assets/assets/icons/contact-filled.svg';
import { ContactNumberText, HotlineInfo } from './ContactMenu';
import Modal, { ModalType } from '../Modal/Modal';
import { useHotlineConfig } from 'common-react';
import { ReactComponent as PhoneIcon } from 'common-assets/assets/icons/icon-phone.svg';
import { Icon } from '../../Icon/Icon';
import { Typography } from '../../Typography/Typography';
import { MenuItem } from '@material-ui/core';

import useStyles from './ContactMenu.style';

const ContactMenuMobile: React.FC = () => {
  const c = useStyles({});
  const [t] = useTranslation('header');
  const [showMobileContactMenu, setShowMobileContactMenu] = useState(false);
  const contactMenuId = 'contact-menu';
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const hotlineConfig = useHotlineConfig();

  const handleContactMobileMenuClose = () => {
    setShowMobileContactMenu(false);
    menuButtonRef.current?.focus();
  };

  return (
    <div className={c.root}>
      <button
        className={c.button}
        onClick={() => setShowMobileContactMenu(true)}
        ref={menuButtonRef}
        aria-haspopup="menu"
        aria-controls={contactMenuId}
        aria-expanded={showMobileContactMenu}
        aria-label={t('contact-menu.title')}>
        <Icon className={c.buttonIcon}>
          <ContactIcon />
        </Icon>
      </button>
      {showMobileContactMenu &&
        <Modal
          type={ModalType.menuModal}
          className={c.contactMenuModal}
          handleClose={handleContactMobileMenuClose}
          title={t('contact-menu.title')}
          withPortal={true}
        >
        <MenuItem disabled className={c.menuItemPhoneHeader}>
          <Icon className={c.menuItemPhoneIcon}><PhoneIcon /></Icon>
          <Typography>{t("contact-menu.contact")}</Typography>
        </MenuItem>
        {hotlineConfig?.premiumPhoneNumber.link && hotlineConfig.premiumPhoneNumber.formatted && <a
          className={clsx(c.menuItem, c.menuItemPhone)}
          key="contact-number-menuitem"
          data-testid={'contact-number-menuitem'}
          href={`tel:${hotlineConfig.premiumPhoneNumber.link}`}
        >
          <div className={clsx(c.menuItemBox, c.menuItemBoxPhone)}>
            <ContactNumberText number={hotlineConfig.premiumPhoneNumber.formatted} />
          </div>
        </a>}
        {hotlineConfig?.standardPhoneNumber.link && hotlineConfig.standardPhoneNumber.formatted && <a
          className={clsx(c.menuItem, c.menuItemPhone)}
          key="contact-landline-number-menuitem"
          data-testid={'contact-landline-number-menuitem'}
          href={`tel:${hotlineConfig.standardPhoneNumber.link}`}
        >
          <div className={clsx(c.menuItemBox, c.menuItemBoxPhone)}>
            <ContactNumberText number={hotlineConfig.standardPhoneNumber.formatted} />
          </div>
        </a>}
        <HotlineInfo key="hotline-info" hotlineConfig={hotlineConfig}/>
      </Modal>}
    </div>
  );
}

export default ContactMenuMobile;
